import { createContext, useState } from "react";

export const UserContext = createContext();

// This context provider is passed to any component requiring the context

const listaIglesias = {LasVegas: {
 
  name:"Centro de Adoracion Familiar CAF ",
  city: "Las Vegas ",
  address: "2010 Haren Dr, Henderson ",
  zipCode: "89011 ",
  contact:"Juan Almanza",
  email:"pastor@iglesiacaf.org",
  phoneNumber: "(725)268-4778",
  website: "https://www.iglesiacaf.org/",
  state: "Nevada",

                            },  
Denville: {
 
  name:"Iglesia Bautista Familia de Dios ",
  city: "Denville, New Jersey ",
  address: "263 Diamond Spring Rd, NJ ",
  zipCode: "07834 ",
  contact:"Daniel Cali",
  email:"danieltocali@gmail.com",
  phoneNumber: "(973) 397-0818 ",
  website: "",
  state: "New Jersey",

  



                            },  
McAllen: {
 
  name:"Iglesia Poder de Dios ",
  city: "Pharr, ",
  address: "1308 S Veterans Blvd. ",
  zipCode: "78577 ",
  contact:"Armando Vera",
  email:"pastorarmandovera@gmail.com",
  phoneNumber: "(956) 900-1379",
  // phoneNumber: "(956) 900-1379",
  website: "",
  state: "Texas",

                            },  

                            Nogales: {
 
                              name:"El Mesias United Methodist Church ",
                              city: "Nogales, ",
                              address: "1050 W Mariposa St",
                              zipCode: "85621 ",
                              contact:"Raul Velazquez",
                              email:"",
                              phoneNumber: "(520) 285-6928",
                              website: "",
                              state: "Arizona",
                            
                                                        },  

ElPaso: {
 
  name:"Living Covenant Church ",
  city: "El Paso, ",
  address: "9401 Carnegie Av, ",
  zipCode: "79915 ",
  contact:"Moses Borja",
  email:"moeborjas@gmail.com",
  phoneNumber: "(915)-319-1389",
  website: "",
  state: "Texas",

                            },  
// Denver: {
 
//   name:"Iglesia San Cayetano ",
//   city: "Denver, ",
//   address: "299 S Raleigh St., ",
//   zipCode: "80219 ",
//   contact:"Linda Sosa",
//   email:"lsosa19@yahoo.com",
//   phoneNumber: "(303) 257-8789",
//   website: "",
//   state: "Colorado",

//                             },  

NewLondon: {
 
  name:"Church of the City ",
  city: "New London, ",
  address: "250 State St. ",
  zipCode: "06320 ",
  contact:"Betzaida Garcia",
  email:"jbrialespr@gmail.com",
  phoneNumber: "(860) 822-3250",
  website: "",
  state: "Connecticut",

                            },
Chicago: {
 
  name:"Impact Church",
  city: "Glenwood, ",
  address: "130 E. Main St ",
  zipCode: "60425 ",
  contact:"Jorge Fuentes",
  email:"jorgemusic@gmail.com",
  phoneNumber: " (708) 219 1639",
  website: "",
  state: "Illinois",

                            },  
 
// Huston: {
 
//   name:"Iglesia de Dios Esperanza de Vida ",
//   city: "Huston, ",
//   address: "10720 Braes Bend  Dr ",
//   zipCode: "77071 ",
//   contact:"Basilio Miranda",
//   email:"andresmira@hotmail.com",
//   phoneNumber: "(423) 310-3002",
//   website: "https://www.iglesiadediosesperanzadevida.org/",
//   state: "Texas",

//                             },
Tucson: {
 
  name:"Iglesia de Dios Comunidad de Amor",
  city: "Tucson, ",
  address: "2518 S Plumer Ave ",
  zipCode: "85713 ",
  contact:"Tirso Rubin",
  email:"tirsorubin@hotmail.com",
  phoneNumber: "(520) 496-7214",
  website: "https://www.comunidaddeamor.org/",
  state: "Arizona",

                            },


}

export const UserProvider = ({ children }) => {

  const [name, setName] = useState("William");
  const [location, setLocation] = useState("No info");
  const [day, setDay] = useState("No info")
  const [hour,setHour] = useState("No info")
  const [lista,setIglesias] = useState(listaIglesias)

  const [nombre,setNombre] = useState("No info")
  const [direccion,setDireccion] = useState("No info")
  const [ciudad,setCiudad] = useState("No info")
  const [estado,setEstado] = useState("No info")
  const [zipCode,setZipCode] = useState("No info")
  const [email, setEmail] = useState("No info")
  const [dosis, setDosis] = useState("No info")
  const [telefono,setTelefono] = useState("No info")
  const [dob,setDob] = useState("No info")
  const [sexo,setSexo] = useState("No info")
  const [uid,setUid] = useState("")
  const [locale,setLocale] = useState("es")
  const [admin,setAdmin] = useState("")
  // const [completAdress,setCompletAdress] = useState("No info")

  return (
    <UserContext.Provider
      value={{
        name,
        location,
        day,
        hour,
        lista,
        nombre,
        direccion,
        ciudad,
        estado,
        zipCode,
        email,
        dosis,
        telefono,
        dob,
        sexo,
        uid,
        locale,
        admin,

        setLocale,
        setName,
        setLocation,
        setDay,
        setHour,
        setNombre,
        setDireccion,
        setCiudad,
        setEstado,

        setZipCode,
        setEmail,
        setDosis,
        setTelefono,
        setDob,
        setSexo,
        setIglesias,
        setUid,
        setAdmin,


      }}
    >
      {children}
    </UserContext.Provider>
  );
};